import { useTranslation } from 'react-i18next'

import { ArrowSquareOutIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Link, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const RelatedInfoItem = ({ icon: Icon, label, linkText, linkUrl, chip, date, timeZone }) => {
  const theme = useTheme()
  const { i18n } = useTranslation()

  return (
    <Styles.ItemContainer>
      <Styles.ItemContent>
        <Icon size={24} weight="light" />
        <Styles.LinkContainer>
          <Text type="bodyMMedium">{label}:</Text>
          <Link href={linkUrl} target="_blank" rel="noopener noreferrer">
            <Text type="linkM">{linkText}</Text>
            <ArrowSquareOutIcon size={24} />
          </Link>
        </Styles.LinkContainer>
        {chip}
      </Styles.ItemContent>
      {date && (
        <Text type="allCapsS" color={theme.colors.text.muted}>
          {new Intl.DateTimeFormat(i18n.language, { dateStyle: 'medium', timeZone }).format(new Date(date))}
        </Text>
      )}
    </Styles.ItemContainer>
  )
}

export default RelatedInfoItem
